module.exports = __webpack_public_path__ + "static/media/water-wave-facebook.56a5899c.png";